module.exports = function ClientFilterSubscribeResponse(selected, errors) {
    this.selected = selected;
    this.errors = errors;

    this.isSuccess = function() {
        return errors.length === 0;
    };
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control-client/client-filter-subscribe-response.js
// module id = 288
// module chunks = 1